import React from "react";
import { MessageCircle } from "lucide-react";
import { useChat } from "../context/ChatContext";

/**
 * Pulsante "Chat" per la navbar. Apre il pannello flottante e mostra il pallino
 * rosso con il numero di messaggi non letti. Usato sia lato utente (di fianco a
 * Outlet) sia lato admin (a destra del CRM), oltre che nel menu mobile.
 */
export default function ChatNavButton({ mobile = false, onOpened }) {
  const { setOpen, unread } = useChat();

  const handle = () => {
    setOpen(true);
    onOpened?.();
  };

  if (mobile) {
    return (
      <button
        type="button"
        onClick={handle}
        data-testid="nav-chat-toggle-mobile"
        className="text-sm tracking-[0.15em] uppercase inline-flex items-center gap-2 text-ink"
      >
        <MessageCircle size={15} /> Chat
        {unread > 0 && (
          <span className="min-w-[16px] h-4 px-1 inline-flex items-center justify-center rounded-full bg-rose-600 text-cream text-[9px] font-semibold leading-none">
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handle}
      data-testid="nav-chat-toggle"
      data-unread={unread}
      title={unread > 0 ? `${unread} messaggi non letti` : "Chat"}
      className="relative inline-flex items-center gap-2 text-[13px] tracking-[0.15em] uppercase text-slate1 hover:text-ink transition-colors"
    >
      <MessageCircle size={14} /> Chat
      {unread > 0 && (
        <span
          className="absolute -top-2 -right-4 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-rose-600 text-cream text-[9px] font-semibold leading-none animate-pulse"
          data-testid="nav-chat-unread-badge"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
